var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.000000, -55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FEFDFD",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3890785,5.20082068 L6.3890785,10.7991793 C6.3890785,11.0200932 6.5681646,11.1991793 6.7890785,11.1991793 C6.8757388,11.1991793 6.96005524,11.1710354 7.02934082,11.1189824 L10.7552109,8.31980309 C10.9318333,8.18710987 10.9674449,7.93636005 10.8347517,7.75973768 C10.8121171,7.72960978 10.7853388,7.70283146 10.7552109,7.68019691 L7.02934082,4.88101759 C6.85271845,4.74832437 6.60196862,4.78393599 6.46927541,4.96055836 C6.41722239,5.02984394 6.3890785,5.11416038 6.3890785,5.20082068 Z",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a6ffe79b.svg";
export { ForwardRef as ReactComponent };